import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'in1000',
    ecrans: ['00-2'],
    params: ['doccleint']
});
